import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TRoleType {
  code: string;
  name: string;
  valid: boolean;
  description: string;
}

export interface IRoleType extends TRoleType {}

const RoleType = Model(
  (model: TRoleType): IRoleType => {
    const _roleType: TRoleType = Object.assign({}, model);

    let create = (roleType: IRoleType): IRoleType => {
      let obj = ValidatableObject(roleType);
      return obj;
    };

    let roleType = {
      get code() {
        return _roleType.code;
      },
      set code(value) {
        _roleType.code = value;
      },
      get name() {
        return _roleType.name;
      },
      set name(value) {
        _roleType.name = value;
      },
      get valid() {
        return _roleType.valid;
      },
      set valid(value) {
        _roleType.valid = value;
      },
      get description() {
        return _roleType.description;
      },
      set description(value) {
        _roleType.description = value;
      }
    };

    return create(roleType);
  }
);

export default RoleType;
